module.exports = __webpack_public_path__ + "static/media/YM81_3.16cc5be0.jpg";